
import React from "react";
import type { Database } from "@/integrations/supabase/types";
import FolderShareButton from "./FolderShareButton";

type Folder = Database['public']['Tables']['folders']['Row'];

interface FolderHeaderSectionProps {
  folderData: Folder;
  projectId: string;
  isShared: boolean;
  subfolderCount?: number;
  assessmentCount?: number;
}

export const FolderHeaderSection: React.FC<FolderHeaderSectionProps> = ({
  folderData,
  projectId,
  isShared,
  subfolderCount = 0,
  assessmentCount = 0,
}) => {
  return (
    <div className="rounded-xl border border-border bg-gradient-to-br hero-dark-gradient p-4 sm:p-6 shadow-sm animate-fade-in">
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-xl font-semibold text-foreground">{folderData.name}</h2>
          {folderData.description && (
            <p className="text-sm text-foreground/80 mt-0.5">{folderData.description}</p>
          )}
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <span className="px-2 py-1 text-xs rounded-md bg-white/10 text-foreground border border-white/20">
              {subfolderCount} mappar
            </span>
            <span className="px-2 py-1 text-xs rounded-md bg-white/10 text-foreground border border-white/20">
              {assessmentCount} sammanställningar
            </span>
            {isShared && (
              <span className="px-2 py-1 text-xs rounded-md bg-white/20 text-foreground">
                Delad mapp
              </span>
            )}
          </div>
        </div>
        
        {/* Add share button if we're viewing a specific folder and not shared */}
        {!isShared && (
          <FolderShareButton 
            folderId={folderData.id}
            projectId={projectId}
            folderName={folderData.name}
          />
        )}
      </div>
    </div>
  );
};
